import { Box, Switch, Typography, FormControlLabel } from '@mui/material';

import { PasswordField } from 'src/pages/channel/shared';
import { ChannelStepLayout } from 'src/pages/channel/shared/channel-step-layout';

import { Iconify } from 'src/components/iconify';
import { Form, Field } from 'src/components/hook-form';

import { useEmailSMTP } from '../hooks/useEmailSMTP';

export const EmailSMTP = () => {
  const { methods, onSubmit, watchSmtpEnabled, btnDisableHandler, t } = useEmailSMTP();

  const renderFields = () => (
    <Box sx={{ width: '60%', alignSelf: 'end' }}>
      {watchSmtpEnabled && (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: 3.5,
          }}
        >
          <Field.Text
            name="smtpAddress"
            label={t('ADDRESS')}
            InputLabelProps={{ shrink: true }}
            placeholder={t('ENTER_SMTP_ADDRESS')}
          />

          <Field.Number
            name="smtpPort"
            label={t('PORT')}
            type="number"
            InputLabelProps={{ shrink: true }}
            placeholder={t('ENTER_SMTP_PORT')}
          />

          <Field.Text
            name="smtpLogin"
            label={t('LOGIN')}
            InputLabelProps={{ shrink: true }}
            placeholder={t('ENTER_SMTP_LOGIN')}
          />

          <PasswordField name="smtpPassword" label={t('SMTP_PASSWORD') || t('PASSWORD')} />

          <Field.Text
            name="smtpDomain"
            label={t('SMTP_DOMAIN')}
            InputLabelProps={{ shrink: true }}
            placeholder={t('ENTER_SMTP_DOMAIN')}
          />
          {!watchSmtpEnabled && (
            <Box
              sx={{
                textAlign: 'center',
                py: 6,
                color: 'text.secondary',
              }}
            >
              <Iconify icon="solar:letter-bold" width={48} sx={{ mb: 2, opacity: 0.5 }} />
              <Typography variant="body2">{t('SMTP_DISABLED_MESSAGE')}</Typography>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
  const enableProviderConfigTitle = t('ENABLE_PROVIDER_CONFIGURATION').replace(
    '{PROVIDER_NAME}',
    t('SMTP')
  );

  const sendProviderDetailsTitle = t('SEND_PROVIDER_DETAILS').replace('{PROVIDER_NAME}', t('SMTP'));

  return (
    <Form methods={methods} onSubmit={onSubmit}>
      <ChannelStepLayout title="" isNextDisabled={btnDisableHandler()}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3.5 }}>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 0.8,
                ml: 8,
              }}
            >
              <Typography variant="subtitle1">{t('SMTP')}</Typography>

              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {sendProviderDetailsTitle}
              </Typography>
            </Box>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 0.8,
                width: '60%',
              }}
            >
              <FormControlLabel
                control={
                  <Switch
                    {...methods.register('smtpEnabled')}
                    checked={watchSmtpEnabled}
                    onChange={(e) => methods.setValue('smtpEnabled', e.target.checked)}
                  />
                }
                label={<Typography variant="subtitle1">{enableProviderConfigTitle}</Typography>}
              />

              <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                {t('ENABLE_SMTP_DESCRIPTION')}
              </Typography>
            </Box>
          </Box>

          {renderFields()}
        </Box>
      </ChannelStepLayout>
    </Form>
  );
};
